import clsx from 'clsx'
import SelectSearch from 'react-select-search'

/* styling */
import styles from './_.module.css'

interface Props {
  className: string
  values: { [key: string]: string | undefined }
  themes: { name: string; value: string }[]
  handleFilterChange: (key: string, value: string) => void
}

function FilterDropdown({
  className,
  values,
  themes,
  handleFilterChange
}: Props) {
  return (
    <div className={clsx(className)}>
      {/* <SelectSearch
        className={(key: string) => styles[key]}
        onChange={value =>
          handleFilterChange('country', value as unknown as string)
        }
        value={'country'}
        options={countryList.map(item => ({
          name: item.name,
          value: item.name
        }))}
        placeholder="Country"
        search={true}
        debounce={500}
      /> */}

      <SelectSearch
        className={(key: string) => styles[key]}
        onChange={value =>
          handleFilterChange('theme', value as unknown as string)
        }
        value={values.theme}
        options={themes.map(item => ({
          name: item.name,
          value: item.value
        }))}
        placeholder="Theme"
        search={true}
      />
    </div>
  )
}

export default FilterDropdown
